import translationEN from "./en.json";
import translationTR from "./tr.json";
import translationES from "./es.json";
import translationFR from "./fr.json";

export const AvailableLanguages = {
  en: {
    name: "English",
    translation: translationEN,
  },
  tr: {
    name: "Türkçe",
    translation: translationTR,
  },
  es: {
    name: "Español",
    translation: translationES,
  },
  fr: {
    name: "Français",
    translation: translationFR,
  }
};
